/**
 * Returns a new patrollers list with the certification object added to (certified)
 * or removed from (not certified) the given patroller. Certifications are stored as
 * full objects, matching what the initial load produces.
 */
export const applyCertificationChange = (patrollers, patrollerId, certification, certified) => {
    return patrollers.map(p => {
        if (p.id !== patrollerId) {
            return p;
        }

        const current = p.certifications || [];
        const without = current.filter(c => c?.id !== certification.id);

        return { ...p, certifications: certified ? [ ...without, certification ] : without };
    });
};
